// eslint-disable-next-line
import * as actions from "constants/orderConstants";

interface IActions {
  type: string;
  payload?: string;
}

export const ongoingOrderReducer = (
  state = { ongoingOrder: {} },
  action: IActions
) => {
  switch (action.type) {
    case actions.ORDER_ADD_REQUEST:
      return { loading: true };
    case actions.ORDER_ADD_SUCCESS:
      return { loading: false, ongoingOrder: action.payload, success: false };
    case actions.ORDER_PAY_SUCCESS:
      return { loading: false, ongoingOrder: action.payload, success: true };
    case actions.ORDER_ADD_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const inOrderReducer = (state = { orders: [] }, action: IActions) => {
  switch (action.type) {
    case actions.ORDER_IN_GET_REQUEST:
      return { loading: true };
    case actions.ORDER_IN_GET_SUCCESS:
      return { loading: false, orders: action.payload };
    case actions.ORDER_IN_GET_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const outOrderReducer = (state = { orders: [] }, action: IActions) => {
  switch (action.type) {
    case actions.ORDER_OUT_GET_REQUEST:
      return { loading: true };
    case actions.ORDER_OUT_GET_SUCCESS:
      return { loading: false, orders: action.payload };
    case actions.ORDER_OUT_GET_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const getTransactionReducer = (
  state = { transaction: {} },
  action: IActions
) => {
  switch (action.type) {
    case actions.ORDER_SINGLE_REQUEST:
      return { loading: true, transaction: state.transaction };
    case actions.ORDER_SINGLE_SUCCESS:
      return { loading: false, transaction: action.payload };
    case actions.ORDER_SINGLE_ERROR:
      return {
        loading: false,
        error: action.payload,
        transaction: state.transaction,
      };
    default:
      return state;
  }
};
